import React, { useState, useEffect } from 'react';
import {
  Upload,
  Button,
  Icon,
  Input,
  Dropdown,
  Menu,
  message,
  Typography,
  Tooltip,
  Divider,
  Table,
  Tag,
  Tabs,
  Popconfirm
} from "antd";
import { platformApi } from '../../../api';
const { Title } = Typography;
const { Dragger } = Upload;
const { Search } = Input;
const { Item } = Menu;
const { TabPane } = Tabs;
import { useContext } from 'react';
import {ContextAPI} from "../../../ContextAPI"
import './VehiclePDFUpload.less';
import AddNumberPlating from './AddNumberPlating';
import ViewNumberPlating from './ViewNumberPlating';
import ChangeOrderStatusReceived from './ChangeOrderStatusReceived';
import ChangeOrderStatusFixed from './ChangeOrderStatusFixed';

const VehiclePDFUpload = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [status,setStatus] = useState("ORDERED");
  const [search, setSearch] = useState("");
  const [addFlag, setAddFlag] = useState(false);
  const [editReceivedFlag,setEditReceivedFlag] = useState(false);
  const [editFixedFlag,setEditFixedFlag] = useState(false);
  const [viewFlag,setViewFlag] = useState(false);
  const { loginCredintials } = useContext(ContextAPI);
  const [modifyAccess, setModifyAccess] = useState(false);
  const [deleteAccess,setDeleteAccess] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  useEffect(() => {
    loginCredintials.roleAccess &&
      loginCredintials.roleAccess.map((each) => {
        if (each.subModule === "number_plate_ordering") {
          if (each.access.update) {
            setModifyAccess(true);
          }
          if (each.access.delete) {
            setDeleteAccess(true);
          }
        }
      });
  }, []);

  const getNumberplating = () => {
    setLoading(true);
    platformApi.post(`/api/numberplate/get`, {
      searchString: search,
      page: page,
      size: limit,
      status:status
    }).then((res) => {
      setData(res.data.data.numberPlates);
      setCount(res.data.data.count);
      setLoading(false);
    }).catch((err) => {
      console.error("error getting number plating:", err);
      setLoading(false);
    });
  };

  useEffect(() => {
    getNumberplating();
  }, [page, limit, search,status]);

  const openModal = (id, isEdit) => {
    const rowData = data.find(item => item.id === id);
    setSelectedRowData(rowData);
    setViewFlag(true);
  };

  const handleRowClick = (record) => {
      openModal(record.id, true);
  };


  const deleteNumberPlating = (id) => {
    platformApi.delete(`/api/numberplate/${id}`).then((res)=>{
      message.success("Delete Number plate details successfully")
      getNumberplating();
    }).catch((err)=>{
      message.error("Error Deleting numberplate");
    })
  }

  const columns = [
    {
      title: 'S.No',
      key: 'sno',
      render: (text, record, index) => (page - 1) * limit + index + 1,
      width: 40,
    },
    {
      title: 'Date',
      key: 'date',
      render: (text, record) => {
        let date;
        if (status === "ORDERED") date = record.orderedDate || record.createdAt;
        else if (status === "RECEIVED") date = record.receivedDate || record.createdAt;
        else if (status === "FIXED") date = record.fixedDate || record.createdAt;
        else date = record.createdAt; // fallback for ALL tab
  
        return date ? new Date(date).toLocaleDateString('en-GB') : "-";
      },
      width: 78,
    },
    {
      title: 'Customer Name',
      dataIndex: 'customerName',
      key: 'customerName',
      width:120
    },
    {
      title: 'Model Name',
      dataIndex: 'modelName',
      key: 'modelName',
      width: 260,
      render: (text) => (
        <span className="vehicle-name" title={text || undefined}>
          {text}
        </span>
      ),
    },
    {
      title: 'Chassis No',
      dataIndex: 'chassisNo',
      key: 'chassisNo',
      width:142
    },
    ...(status === "RECEIVED"
      ? [
          {
            title: 'Location',
            dataIndex: 'Location',
            key: 'Location',
            render: (text) => <span>{text?.name || "-"}</span>,
            width: 100,
          },
        ]
      : []),
    // {
    //   title: 'Branch',
    //   dataIndex: 'branchName',
    //   key: 'branchName',
    //   width:100
    // },
    {
      title: 'Register No',
      dataIndex: 'registerNo',
      key: 'registerNo',
      width:90
    },
    {
      title: 'Order Status',
      dataIndex: 'plateOrderStatus',
      key: 'plateOrderStatus',
      width:70,
      render: (status) => (
        <Tag 
          color={status === 'ORDERED' ? 'orange' : 'green'}
          style={{
            width: '70px',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          {status}
        </Tag>
      ),
    },
    ...(modifyAccess || deleteAccess ? [
      {
        title: "Action",
        key: "action",
        width:60,
        render: (data) => (
          <div>
            {/* {modifyAccess && (
              <span
                onClick={(event) => {
                  event.stopPropagation();
                  openModal(data.id, true);
                }}
                className="linkylink"
              >
                Modify
                <Divider type="vertical" />
              </span>
            )} */}
            {deleteAccess && (
              <Popconfirm
                title="Are you sure you want to delete this record?"
                onConfirm={(e) => {
                  e.stopPropagation();
                  deleteNumberPlating(data.id);
                }}
                okText="Yes"
                cancelText="No"
                placement="topRight"
              >
                <span
                  onClick={(event) => event.stopPropagation()}
                  className="linkylink"
                >
                  Delete
                </span>
              </Popconfirm>
            )}
          </div>
        ),
      }]:[])
  ];

  const getMenu = () => {
    let size = Math.ceil(count / 10);
    let menus = [5,10,15,20,25,30];
    // menus.push(10);
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item
        onClick={() => setLimit(menu)}
        key={menu}
      >
        {menu}
      </Item>
    ));
  };

  const handleTabChange = (activeKey) => {
    setStatus(activeKey);
    setPage(1); 
  };

  const menu = <Menu>{getMenu()}</Menu>;

  return (
    <div>
      <div className="accessories-head">
        <Title style={{ width: "60%" }} level={4}>
          Number Plate Ordering [{count}]
          <span style={{ margin: ".5rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit} &nbsp;
                <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <Search
          style={{ width: "30%" }}
          placeholder="Search by customer, model, or chassis"
          onSearch={(value) => {
            setPage(1);
            setSearch(value);
          }}
          onChange={(e) => {
            if (e.target.value === "") {
              setSearch("");
              setPage(1);
            }
          }}
          allowClear
        />
        <div style={{ display: "flex" }}>
          <Button
            onClick={() => setEditReceivedFlag(true)}
            style={{ margin: "0 1%", width: "100%" }}
            type="primary"
          >
            Add Received
          </Button>
        </div>
        <div style={{ display: "flex" }}>
          <Button
            onClick={() => setEditFixedFlag(true)}
            style={{ margin: "0 1%", width: "100%" }}
            type="primary"
          >
            Add Fixed
          </Button>
        </div>
        <div style={{ display: "flex" }}>
          <Button
            onClick={() => setAddFlag(true)}
            style={{ margin: "0 1%", width: "100%" }}
            type="primary"
          >
            Add Number plate Ordering
          </Button>
        </div>
      </div>

      <Tabs 
        activeKey={status} 
        onChange={handleTabChange}
        style={{ marginBottom: 16 }}
      >
        <TabPane tab="Ordered" key="ORDERED" />
        <TabPane tab="Received" key="RECEIVED" />
        <TabPane tab="Fixed" key="FIXED" />
        <TabPane tab="All" key="ALL" />
      </Tabs>

      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        loading={loading}
        onRow={(record) => {
          return {
            onClick: () => handleRowClick(record),
          }}}
        scroll={{ x: 'max-content' }}
        pagination={{
          current: page,
          pageSize: limit,
          total: count,
          showSizeChanger: false,
          onChange: (page, pageSize) => {
            setPage(page);
            setLimit(pageSize);
          },
        }}
        className="compact-table"
      />

      {addFlag && (
        <AddNumberPlating
          open={addFlag}
          close={() => setAddFlag(false)}
          reloadData={getNumberplating}
        />
      )}

      {viewFlag && (
        <ViewNumberPlating
          open={viewFlag}
          close={() => {
            setViewFlag(false);
            setSelectedRowData(null);
          }}
          reloadData={getNumberplating}
          rowData={selectedRowData}
        />
      )}

      {editReceivedFlag &&
      <ChangeOrderStatusReceived
      open={editReceivedFlag}
      close={()=>{setEditReceivedFlag(false)}}
      reloadData={getNumberplating}
      />
      }

     {editFixedFlag &&
      <ChangeOrderStatusFixed
      open={editFixedFlag}
      close={()=>{setEditFixedFlag(false)}}
      reloadData={getNumberplating}
      />
      }
    </div>
  );
};

export default VehiclePDFUpload;